"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeObjectInLocalStorage = storeObjectInLocalStorage;
exports.getItemFromLocalStorage = getItemFromLocalStorage;
exports.getObjectFromLocalStorage = getObjectFromLocalStorage;
exports.removeObjectFromLocalStorage = removeObjectFromLocalStorage;
/**
 * storeObjectInLocalStorage
 * @param  itemId    - id to get from local storage
 * @param  item      - object to store to store
 */
function storeObjectInLocalStorage(itemId, item) {
    if (itemId)
        window === null || window === void 0 ? void 0 : window.localStorage.setItem(itemId, JSON.stringify(item));
}
/**
 * getItemFromLocalStorage
 * @param  itemId    - id to get from local storage
 */
function getItemFromLocalStorage(itemId) {
    return window === null || window === void 0 ? void 0 : window.localStorage.getItem(itemId);
}
/**
 * getObjectFromLocalStorage
 * @param  itemId    - id to get from local storage
 */
function getObjectFromLocalStorage(itemId) {
    var item = getItemFromLocalStorage(itemId) || null;
    return item && JSON.parse(item);
}
/**
 * removeObjectFromLocalStorage
 * @param  itemId    - id to get from local storage
 */
function removeObjectFromLocalStorage(itemId) {
    return window === null || window === void 0 ? void 0 : window.localStorage.removeItem(itemId);
}
